export class ToTopBtnChecker {
    constructor() {
        this.windowWidth = 0;
        this.windowWidthThen = 0;
        this.isBtnFixed = false;
        this.windowWidthThen = window.innerWidth;
    }
    setProps(el, props) {
        for (let key in props) {
            el.style.setProperty('--' + key, props[key]);
        }
    };
    clamp(v, min, max) {
        return min > v ? min : max < v ? max : v;
    }
    round(n) {
        return Math.round(n * 10000) / 10000;
    }

    calcElementOffsetY(elem) {
        let container = window;

        let parentElem;
        if (elem.parentElement) {
            parentElem = elem.parentElement;
        }
        let target = parentElem;

        // ページ全体に対するY座標を計算
        let numY = 0;
        do {
            numY += target.offsetTop; //target.offsetTop;はノードの上端に対しての現在の要素の距離
            target = target.offsetParent;
            //console.log(target);
        } while (target && target !== container); //要素のcontainerに対するY座標

        return numY;
    }



    onUpdate() {
        this.body = document.getElementsByTagName('body')[0];
        this.html = document.getElementsByTagName('html')[0];
        //let windowLeft = (window.screenLeft || window.screenX || 0);
        //let windowTop = (window.screenTop || window.screenY || 0);
        //let windowWidth = (window.innerWidth || document.documentElement.clientWidth || 0);
        let windowHeight = (window.innerHeight || document.documentElement.clientHeight || 0);
        let windowScrollY = window.scrollY || window.pageYOffset;
        //let windowScrollX = window.scrollX || window.pageXOffset;

        // 汎用
        if (windowScrollY > 200) {
            this.body.classList.add('scrolled-title');
        } else {
            this.body.classList.remove('scrolled-title');
        }

        // ページの #js-btn-totop が .fixed 有りならばスクロールチェック
        if (document.getElementById('js-btn-totop')) {
            let elem = document.getElementById('js-btn-totop');
            if (elem.classList.contains('fixed')) {
                this.isBtnFixed = true;
                //console.log('isBtnFixed = true');
            }
        }

        //BtnToTop
        if (this.isBtnFixed) {
            if (document.getElementById('js-btn-totop') &&
                document.getElementById('js-spacer-footer-top')
            ) {
                let elem = document.getElementById('js-btn-totop');
                let elemFooter = document.getElementById('js-spacer-footer-top');
                let rectFooter = elemFooter.getBoundingClientRect(); // 要素の位置座標
                let y = rectFooter.bottom; //画面の上端から、要素の下端までの距離
                if (windowHeight >= y) {
                    //フッターが見えたらtoTopボタンをrelativeにする
                    elem.classList.add('relative');
                } else {
                    elem.classList.remove('relative');
                }
                //console.log('#js-spacer-footer-topの画面上の位置=' + y);
            }
        }
    }


    // onResize() {
    //     //console.log('onResizeMov');
    //     if (this.isBtnFixed) {
    //         this.onUpdate();
    //     }
    // }


    // 初期化
    // init() {
    //     this.windowWidthThen = window.innerWidth;
    //     // ページの #js-btn-totop が .fixed 有りならばスクロールチェック
    //     if (document.getElementById('js-btn-totop')) {
    //         let elem = document.getElementById('js-btn-totop');
    //         if (elem.classList.contains('fixed')) {
    //             this.isBtnFixed = true;
    //             console.log('isBtnFixed = true');
    //         }
    //     }
    // }
}